// Imports
import { lighten, saturate } from 'polished';
import { createGlobalStyle } from 'styled-components/macro';
import { GeneratedThemeProps } from './template-style';


// Global styles
const FreshStyle = createGlobalStyle<{ theme: GeneratedThemeProps }>`
	#root, #storybook-root {
		min-height: 100vh;
		font-family: ${(props) => props.theme.fontFamily};
		-webkit-font-smoothing: auto;
		color: ${(props) => props.theme.baseColor};
		background: ${(props) => saturate(0.2, lighten(0.3, props.theme.baseColor))};
		background: linear-gradient(to bottom, ${(props) =>
			saturate(0.2, lighten(0.3, props.theme.baseColor))} 0%, #fff 31.25rem);
		
		@media only screen and (max-width: 37.5rem) {
			background: linear-gradient(to bottom, ${(props) =>
				saturate(0.2, lighten(0.3, props.theme.baseColor))} 0%, #fff 15.625rem);
		}
	}
`;

export default FreshStyle;
